import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/sharp-solid-svg-icons/faRotateRight';
import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import style from '../engagement-card.module.less';
import { messages } from '../messages';

export const CreateShippingPresetsBody = () => {
  return (
    <div className={style['card-text']}>
      <Text
        className={style['card-text']}
        formattedMessageValues={{
          icon: <FontAwesomeIcon className={style['inline-icon']} icon={faRotateRight} />,
        }}
        textType={TextType.Paragraph}
        value={messages.createShippingPresetsBodyLineOne}
      />
      <Text className={style['card-text']} textType={TextType.Paragraph} value={messages.createShippingPresetsBodyLineTwo} />
    </div>
  );
};
